





















































import Vue from "vue";
import { Watch, Prop } from "vue-property-decorator";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import { ReportFilter, ReportParameter } from "@/entities";
import { Locales } from "@/i18n/locales";
import XLSX from "xlsx";
import moment from "moment";

@Component({
  components: {
    AdvanceSearchComponent
  }
})
export default class ReportTableComponent extends Vue {

    @Prop() fields!: Array<ReportFilter>;
    @Prop() selectedParams!: Array<ReportParameter>;
    @Prop() headers!: Array<any>;
    @Prop() data!: any;
    @Prop() isLoading!: boolean;
    @Prop() dynamicSlots!: any;


    search: string = '';
    refReport: string = 'reportDataTable';
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    /** Export to excel fns. */
    _btnExport() {
        let expotableItems: any = [];
        let defaultSheetName = "Sheet1";
        let defaultFileName = "Report";
        let Currency: string;

        let expotableFields = this.headers.map(({ value, text }) => ({
        value,
        text,
        }));

        // @ts-ignore
        let filteredItems = this.$refs[this.refReport].$children[0].filteredItems;

        // Select items with exportable true
        expotableItems = filteredItems.map((o) =>
          expotableFields.reduce((acc, curr) => {
              acc[curr.text] = curr.value in o ? o[curr.value] : "";
              Currency = o['Currency']
              if(curr.value === 'RequestedAmount' || curr.value === 'Spent' || curr.value === 'Forecast' || curr.value === 'BalanceRemaining') {
                acc[curr.text] = this.$services.format.formatCurrency(o[curr.value], Currency || 'EUR', this.defaultLocale)
              }
              else if(curr.value === 'GrantClosingDate' || curr.value === 'GrantSignDate') {
                acc[curr.text] = new Date(o[curr.value]).toLocaleDateString()
              }
              return acc;
          }, {})
        );

        let fileName = `${defaultFileName}_${moment().format("DD-MM-YYYY")}`;

        // Export to excel
        if (expotableItems) {
            var sheet1 = XLSX.utils.json_to_sheet(expotableItems);
            var wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, sheet1, defaultSheetName);
            XLSX.writeFile(wb, `${fileName}.csv`);
        }
  }
    
}
